import React, { useState, useEffect } from "react";
import {
  Button,
  Form,
  Modal,
  Confirm,
  Grid,
  Dropdown,
} from "semantic-ui-react";
import DatePicker from "react-date-picker";
import AdvocatesDropdown from "../components/athletes/AdvocatesDropdown";
import SportList from "../components/athletes/SportList";
import { stringRegex, urlRegex } from "../utils/regex";
import { useDispatch } from "react-redux";
import { addEvent } from "../store/actions/athleteActions";
export const animation = "scale";
export const duration = 500;

const statusOptions = [
  { key: 1, text: "Approve", value: true },
  { key: 2, text: "Pending", value: null },
  { key: 3, text: "Disaaprove", value: false },
];

const EditEvent = (props) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [advocate, setAdvocate] = useState(null);
  const [sport, setSport] = useState(null);
  const [error, setError] = useState(false);
  const [title, setTitle] = useState(null);
  const [url, setUrl] = useState("");
  const [location, setLocation] = useState(null);
  const [submit, setSubmit] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [status, setStatus] = useState();
  const [clearUrl, setClearUrl] = useState(false);
  const [clearAdvocate, setClearAdvocate] = useState(false);
  const dispatch = useDispatch();
  const handleAddEventClose = () => {
    if (startDate || endDate || sport || title || location) {
      setConfirm(true);
    } else close();
  };
  useEffect(() => {
    setAdvocate(props.advocate);
  }, [props.advocate]);
  useEffect(() => {
    setUrl(props.url);
  }, [props.url]);
  const close = () => {
    setConfirm(false);
    setSubmit(false);
    setStartDate(null);
    setEndDate(null);
    setAdvocate(null);
    setSport(null);
    setError(null);
    setTitle(null);
    setUrl(null);
    setLocation(null);
    setStatus(undefined);
    setClearUrl(false);
    setClearAdvocate(false);
    props.close();
  };
  const handleEventChange = (event) => {
    if (event && !stringRegex.test(event)) {
      setTitle(event);
      setError(false);
    } else setError("It should not be empty");
  };
  const handleLocationChange = (location) => {
    if (location && !stringRegex.test(location)) {
      setLocation(location);
      setError(false);
    } else setError("It should not be empty");
  };
  const handleAdvocateChange = (data) => {
    if (data) {
      setAdvocate(data);
      setError(false);
    } else {
      setError("Please select advocate from dropdown");
    }
  };
  const handleSportChange = (data) => {
    if (data) {
      setSport(data);
      setError(false);
    } else {
      setError("Please select sport from dropdown");
    }
  };
  const handleUrlChange = (inputUrl) => {
    if (urlRegex.test(inputUrl)) {
      setUrl(inputUrl);
      setError(null);
    } else {
      setError("Please enter URL");
    }
  };
  const handleSubmit = () => {
    let eventStatus = null;
    let eventAttenders = props.attenders.map((e) => e);
    if (props.superAdmin) {
      if (status === undefined) {
        eventStatus = props.status;
      } else eventStatus = status;
    }
    if (advocate) {
      eventAttenders = [
        ...eventAttenders.filter((visitor) => visitor !== props.advocate),
        advocate,
      ];
    }
    if (clearAdvocate) {
      eventAttenders = [
        ...eventAttenders.filter((visitor) => visitor !== props.advocate),
      ];
    }
    const data = {
      eventId: props.id,
      eventStartDate: startDate ? startDate : new Date(props.startDate),
      eventEndDate: endDate ? endDate : new Date(props.endDate),
      eventAdvocate: clearAdvocate
        ? null
        : advocate
        ? advocate
        : props.advocate
        ? props.advocate
        : null,
      eventSport: sport ? sport : props.sport,
      eventName: title ? title : props.name,
      eventLocation: location ? location : props.location,
      eventCreator: props.creator,
      eventAttenders: eventAttenders,
      eventStatus,
      eventUrl: clearUrl ? null : url ? url : props.url ? props.url : null,
    };
    dispatch(addEvent(data));
    setSubmit(true);
  };
  return (
    <Modal
      className="cu-event-modal"
      onClose={() => handleAddEventClose()}
      open={props.open}
    >
      <Modal.Content scrolling>
        <div className="AdminTopButtonsProgressContainer">
          <div className="AdminTopButtonsContainer">
            <Button
              floated="left"
              circular
              icon="close"
              onClick={() => handleAddEventClose()}
            />
            <Button
              disabled={error ? true : false}
              floated="right"
              positive
              name="saveButton"
              content="Save"
              labelPosition="right"
              icon="checkmark"
              onClick={handleSubmit}
            />
          </div>
          {error && <p style={{ color: "#800000" }}>{error}</p>}
        </div>
        <Form>
          <div className="AdminFormEventContainer">
            <h3>Edit {props.name}</h3>
            <Form.Field>
              <label>Event Name</label>
              <input
                defaultValue={props.name}
                id="ename"
                onChange={(e) => handleEventChange(e.target.value)}
              />
            </Form.Field>
            <Grid divided="vertically">
              <Grid.Row stackable="true" columns={2}>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  <Form.Field>
                    <label>Start Date ({props.startDate})</label>
                    <DatePicker
                      id="sdate"
                      className="cu-datepicker"
                      minDate={new Date()}
                      value={startDate}
                      onChange={setStartDate}
                      placeholderText="Select start date"
                    />
                  </Form.Field>
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  <Form.Field>
                    <label>End Date ({props.endDate})</label>
                    <DatePicker
                      id="edate"
                      className="cu-datepicker"
                      value={endDate}
                      minDate={new Date()}
                      onChange={setEndDate}
                      placeholderText="Select end date"
                    />
                  </Form.Field>
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <Form.Field>
              <label>Event URL</label>
              <div className="inline-input-group">
                <div className="first-div">
                  <input
                    placeholder={clearUrl ? "Enter URL" : props.url}
                    id="event_url"
                    onChange={(e) => handleUrlChange(e.target.value)}
                  />
                </div>
                <Button
                  icon="close"
                  disabled={props.url || url ? false : true}
                  circular
                  basic
                  size="mini"
                  color="red"
                  onClick={() => {
                    setUrl(null);
                    setClearUrl(true);
                  }}
                />
              </div>
            </Form.Field>
            <Form.Field>
              <label>Sport</label>
              <SportList
                defaultValue={props.sport}
                placeholder="Softball"
                onChange={(not, data) => handleSportChange(data.value)}
                name="sportDropdown"
              />
            </Form.Field>
            {(props.role !== "advocate" || props.superAdmin) && (
              <Form.Field>
                <label>
                  {props.role === "advocate" ? "Athlete" : "Advocate"} Name
                </label>

                <div className="inline-input-group">
                  <div className="first-div">
                    <AdvocatesDropdown
                      name="advocatesDropdown"
                      onChange={(not, data) => {
                        handleAdvocateChange(data.value);
                      }}
                      defaultValue={
                        clearAdvocate
                          ? ""
                          : props.advocate
                          ? props.advocate
                          : ""
                      }
                      placeholder={"Select Name"}
                    />
                  </div>
                  <Button
                    icon="close"
                    disabled={props.advocate || advocate ? false : true}
                    circular
                    basic
                    size="mini"
                    color="red"
                    onClick={() => {
                      setAdvocate(null);
                      setClearAdvocate(true);
                    }}
                  />
                </div>
              </Form.Field>
            )}
            <Form.Field>
              <label>Location</label>
              <input
                defaultValue={props.location}
                placeholder="Enter location"
                id="location"
                onChange={(e) => handleLocationChange(e.target.value)}
              />
            </Form.Field>
            {props.superAdmin && (
              <Form.Field>
                <label>Status</label>
                <Dropdown
                  placeholder="select status"
                  selection
                  options={statusOptions}
                  onChange={(not, data) => setStatus(data.value)}
                />
              </Form.Field>
            )}
          </div>
        </Form>
        <Confirm
          open={confirm}
          content="You have unsaved changes.  Are you sure you want to exit?"
          onCancel={() => setConfirm(false)}
          onConfirm={close}
        />
        <Modal onClose={() => setSubmit(false)} open={submit}>
          <Modal.Content>
            <div className="AdminProfileUpdatedContainer">
              <h3>Event Updated!</h3>
              <Button positive name="okButton" content="OK" onClick={close} />
            </div>
          </Modal.Content>
        </Modal>
      </Modal.Content>
    </Modal>
  );
};

export default EditEvent;
